import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
export const Wrapper = styled.div`
    #appsvio-config-page-layout-footer > div:first-child {
        max-width: unset;
    }
`;
export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${token('space.200')};
    width: 85%;
`;
export const PatternSection = styled.div`
    display: flex;
    align-items: center;
    column-gap: ${token('space.050')};
    [data-testid*='jira-expression-pattern'] {
        flex: 1;
    }
`;